import { Injectable } from '@angular/core';
import { LocalStorageService } from '../../services/localStorage.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SidenavHelperService {
  constructor(private _localStorage: LocalStorageService) {}

  getFmhAuthUrl(): string {
    const hqId = this._localStorage.get('hq_id');
    const userId = this._localStorage.get('staff_user_id');
    const fmhAuthUrl = environment.fmhAuthUrl;
    const url = `${fmhAuthUrl}?hq_id=${hqId}&user_id=${userId}`;
    return url;
  }

  getAndoidfmhUrl(): string {
    const androidUrl =
      'https://play.google.com/store/apps/details?id=com.foodmarkethub.deux&hl=en';
    return androidUrl;
  }

  getIosfmhUrl(): string {
    const iosUrl = 'https://apps.apple.com/id/app/food-market-hub/id1547354089';
    return iosUrl;
  }

  getHqLoginUrl(): string {
    const currentOrigin = window.location.origin;
    const hqLoginUrl = `${currentOrigin}/hq/login`;
    return hqLoginUrl;
  }
}
